export const CONVERTER_AMOUNT_VALUES = [
  1, 10, 25, 50, 100, 500, 1000, 5000, 10000,
];
